<template>
    <div>
        <EnrollNavbarSection />
        <EnrollHeaderSection />
        <LanguageSection />
        <EnrollSection />
        <FooterSection />
    </div>
</template>

<script>
import EnrollNavbarSection from '@/components/EnrollNavbarSection.vue';
import EnrollHeaderSection from '@/components/EnrollHeaderSection.vue';
import LanguageSection from '@/components/CurriculumSection.vue';
import EnrollSection from '@/components/EnrollSection.vue';
import FooterSection from '@/components/FooterSection.vue';

export default {
    components: {
        EnrollNavbarSection,
        EnrollHeaderSection,
        LanguageSection,
        EnrollSection,
        FooterSection
    }
}
</script>

<style>

</style>